import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter an email address");
      return;
    }

    setLoading(true);

    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setEmailSent(true);
      toast.success(
        "If an account exists with this email, a password reset link will be sent."
      );
    } catch (error) {
      console.error("Error:", error);
      if (error.code === "auth/invalid-email") {
        toast.error("Please enter a valid email address");
      } else if (error.code === "auth/user-not-found") {
        // For security reasons, we'll show the same message as success
        toast.success(
          "If an account exists with this email, a password reset link will be sent."
        );
        setEmailSent(true);
      } else {
        toast.error("An error occurred. Please try again later.");
      }
    }

    setLoading(false);
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-md w-full space-y-8'>
        <div>
          <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
            Reset your password
          </h2>
          <p className='mt-2 text-center text-sm text-gray-600'>
            Enter your email address and we'll send you a link to reset your
            password
          </p>
        </div>

        {!emailSent ? (
          <form className='mt-8 space-y-6' onSubmit={handleSubmit}>
            <div className='rounded-md shadow-sm -space-y-px'>
              <div>
                <label htmlFor='email-address' className='sr-only'>
                  Email address
                </label>
                <input
                  id='email-address'
                  name='email'
                  type='email'
                  autoComplete='email'
                  required
                  className='appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm'
                  placeholder='Email address'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type='submit'
                disabled={loading}
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed'>
                {loading ? "Sending..." : "Send reset link"}
              </button>
            </div>
          </form>
        ) : (
          <div className='text-center'>
            <div className='mb-4 text-green-600'>
              <svg
                className='mx-auto h-12 w-12'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
            </div>
            <p className='text-gray-700 mb-4'>
              If an account exists with this email, you will receive a password
              reset link shortly.
            </p>
          </div>
        )}

        <div className='text-center'>
          <Link
            to='/login'
            className='font-medium text-blue-600 hover:text-blue-500'>
            Back to Login
          </Link>

          <div>
            <p className='text-sm text-gray-500 mt-1'>
              If you don't receive the email within a few minutes, please check
              your spam folder.
            </p>

            <p className='text-sm text-gray-500 mt-1'>
              If you still don't receive the email, please contact us at
              <a href='mailto:j1listsinfo@gmail.com' className='text-blue-600'>
                j1listsinfo@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
